import React from 'react'
import DynamicColor from '../common/dynamic-color'
import { COLOR_NAME } from '../../constants'
import { useTranslation } from 'react-i18next'
import { clsx } from '../../utils/helper'

const InputFill = ({
    className = '',
    i18nDataError,
    value = '',
    label,
    error,
    numberOnly,
    onChange,
    inputStyle,
    required,
    ...props
}) => {
    const { t } = useTranslation()
    const classes = clsx(['app-input', error && 'error', className])

    const handleChange = e => {
        const { value } = e.target
        if (numberOnly && value.match(/\D/g)) {
            return
        }
        onChange(e)
    }

    return (
        <div className={classes}>
            {label && (
                <DynamicColor
                    style={{ color: COLOR_NAME.BODY_TEXT }}
                    className="app-input__label"
                >
                    {label}
                    {required && (
                        <span className="ml-1 app-input__required">(*)</span>
                    )}
                </DynamicColor>
            )}

            <DynamicColor
                tag="input"
                value={value}
                {...props}
                style={{
                    color: COLOR_NAME.INPUT_TEXT,
                    backgroundColor: COLOR_NAME.INPUT_BG,
                    borderColor: COLOR_NAME.INPUT_LINE,
                    ...inputStyle,
                }}
                onChange={handleChange}
            />

            {/* {error && (
                <div className="app-input__error mt-2 text-left">
                    {t(error, { ...i18nDataError })}
                </div>
            )} */}
        </div>
    )
}

export default InputFill
